import React from 'react';
import { Chips } from '@carnica/ui-kit';
import { Metric } from "../../../../metric";
import { EMetricBlockName } from "../../../../types";
export var ChipsElement = function ChipsElement(_ref) {
  var item = _ref.item,
    handleClick = _ref.handleClick;
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      block_name: EMetricBlockName.keywords,
      title: item.label
    }),
    events: {
      headerMetric: ['handleViewSearchElementBlock']
    },
    mode: "viewport",
    once: true,
    "data-t-id": "blocks-ChipsBlock"
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      block_name: EMetricBlockName.keywords,
      title: item.label
    }),
    events: {
      headerMetric: ['handleClickSearchChips']
    },
    mode: "click",
    "data-t-id": "blocks-ChipsBlock-1"
  }, /*#__PURE__*/React.createElement(Chips, {
    color: "dark",
    invert: true,
    key: item.label,
    label: item.label,
    onClick: function onClick() {
      return handleClick(item.relatedSearch);
    },
    "data-t-id": "blocks-ChipsBlock"
  })));
};